import { render, staticRenderFns } from "./SimpleConfirmationModal.vue?vue&type=template&id=3a80b849&scoped=true"
import script from "./SimpleConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SimpleConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleConfirmationModal.vue?vue&type=style&index=0&id=3a80b849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80b849",
  null
  
)

export default component.exports